import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {MainComponent} from './main/main.component';
import { AuthGuard } from'@mydocma/auth';
import { MydocmaServiceWorkerModule, SingleTabGuard } from '@mydocma/app-container';

const appRoutes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        canActivate: [SingleTabGuard, AuthGuard],
        loadChildren: () => import('../../projects/mydocma-rp/src/lib/rp.module')
          .then(mod => mod.RpModule),
      },
    ],
  },

];

@NgModule({
    imports: [
    MydocmaServiceWorkerModule,
    RouterModule.forRoot(
      appRoutes,
      {
        //TODO: Old. Check if needed
        // preloadingStrategy: PreloadAllModules,
        //scrollOffset: [0, 0],
        //scrollPositionRestoration: 'top',
        //
        paramsInheritanceStrategy: 'always'
      },
    )
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
